export const AwaitExecutorApprove = 0
export const ExecutorApproved = 1
export const ExecutorDeleted = 2
export const ExecutorEdited = 3
export const InvoiceCreated = 4
export const CustomerApproved = 5
export const CustomerDeclined = 6
export const CustomerEdited = 7
export const CustomerEditApprovedByExecutor = 8

export const GetStatusText = status => {
    switch (status) {
        case AwaitExecutorApprove:
            return 'Не подтверждён'

        case ExecutorApproved:
            return 'Подтверждён поставщиком'

        case ExecutorDeleted:
            return 'Удалён поставщиком'

        case ExecutorEdited:
            return 'Исправлен поставщиком'

        case InvoiceCreated:
            return 'Счёт-фактура создан'

        case CustomerApproved:
            return 'Подтверждён заказчиком'

        case CustomerDeclined:
            return 'Отклонён заказчиком'

        case CustomerEdited:
            return 'Исправлен заказчиком'

        case CustomerEditApprovedByExecutor:
            return 'Исправленный вариант подтерждён поставщиком'

        default:
            return 'Не подтверждён'
    }
}

export const GetStatusVariant = status => {
    switch (status) {
        case AwaitExecutorApprove:
            return 'blue-grey darken-4 white--text'
        case ExecutorApproved:
            return 'teal darken-2 white--text'
        case ExecutorDeleted:
            return 'pink darken-4 white--text'
        case ExecutorEdited:
            return 'warning white--text'
        case InvoiceCreated:
            return 'light-blue darken-4 white--text'
        case CustomerApproved:
            return 'green white--text'
        case CustomerDeclined:
            return 'red white--text'
        case CustomerEdited:
            return 'orange darken-3 white--text'
        case CustomerEditApprovedByExecutor:
            return 'teal darken-2 white--text'
        default:
            return 'blue-grey white--text'
    }
}